import { useSyncExternalStore } from 'react'
import {
  getActiveCollectionKey,
  readCollectionScope,
  subscribeActiveCollectionKey,
  subscribeCollectionScope,
  type CollectionScope,
} from '../lib/collectionScope'

// The ONE place a gallery decides whether to ask for owned art. It never
// calls useCollection (that hook does a cloud load per instance). CardName
// and the CommanderSearch chip deliberately do not use this: they are not
// galleries and show the base printing (spec section 4).
export function useCollectionScope(): CollectionScope {
  return useSyncExternalStore(subscribeCollectionScope, readCollectionScope, readCollectionScope)
}

const noKey = (): string | null => null

/**
 * Which cache scope is active: `cb.collection.v2.acct:<id>`, the guest key, or
 * null while the auth state is unknown. Collection screens key their subtree
 * and their queries on it, so nothing from account A renders after a switch
 * to B.
 */
export function useActiveCollectionKey(): string | null {
  return useSyncExternalStore(subscribeActiveCollectionKey, getActiveCollectionKey, noKey)
}
